<template>
  <div class="resource" id="Resource">
    <Header/>
    <div class="other__narrow__banner" id="ResourceHumanResources">
      <img :src="'/upload/' + resource.image" alt="" />
      <div class="other__narrow__banner__title">
        <div class="title_container">
          <h4>{{resource.title}}</h4>
        </div>
      </div>
    </div>

    <div class="resource_section_one_wrapper">
      <div class="container">
        <div class="other__ck__textblock other__reverse">
          <div class="other__ck__block__left">
            <div class="other__ck__title title__bar">
              <h2>{{resourceHumanResources.title}}</h2>
            </div>
            <p v-html="resourceHumanResources.descript"></p>
          </div>
          <div class="other__ck__block__right">
            <div class="other__ck__img resource__img__box">
              <div class="resource_pic_wrapper">
                <img :src="'/upload/' + resourceHumanResources.image" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="other__ck__textblock">
          <div class="other__ck__block__left">
            <div class="other__ck__img resource__img__box">
              <div class="resource_pic_wrapper">
                <img :src="'/upload/' + resourceHumanResources1.image" alt="" />
              </div>
            </div>
          </div>
          <div class="other__ck__block__right">
            <div class="other__ck__title title__bar">
              <h2>{{resourceHumanResources1.title}}</h2>
            </div>
            <p>
              {{resourceHumanResources1.descript}}
            </p>
          </div>
        </div>
      </div>
    </div>
    
    <div class="resource_section_two_wrapper" v-html="resourceHumanResources3.content"></div>

    <div class="resource_section_three_wrapper other__ck__block__bg" >
      <div class="container">
        <div class="other__ck__title title__bar">
          <h2>PHƯƠNG THỨC DỰ TUYỂN</h2>
        </div>
        <div class="other__forms">
          <form class="needs-validation" novalidate>
            <div class="form-row">
              <div class="col-md-6 mb-3">
                <!--你的姓名-->
                <label for="validationCustom01">tên thư của bạn</label>
                <!--請輸入姓名-->
                <input
                v-model="name"
                  type="text"
                  class="form-control"
                  id="validationCustom01"
                  placeholder="Vui lòng nhập tên của bạn"
                  value="name"
                  required
                />
                <!--請輸入姓名-->
                <div class="invalid-feedback">
                  Vui lòng nhập tên của bạn
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <label for="validationCustom02">E-Mail</label>
                <input
                  v-model="email"
                  type="email"
                  class="form-control"
                  id="validationCustom02"
                  placeholder="Vui lòng nhập E-mail"
                  value="email"
                  required
                />
                <!--請輸入email-->
                <div class="invalid-feedback">
                  Vui lòng nhập E-mail
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6 mb-3 without_validate_wrapper">
                <!--聯絡電話-->
                <label for="validationCustom01">Số liên lạc</label>
                <!--請輸入電話-->
                <input
                  v-model="phone"
                  type="text"
                  class="without_validate_input"
                  id="validationCustom01"
                  placeholder="Vui lòng nhập số điện thoại"
                  value="phone"
                />
                <!--請輸入電話-->
                <div class="invalid-feedback">
                  Vui lòng nhập số điện thoại
                </div>
              </div>
              <div class="col-md-6 mb-3 d-flex flex-column">
                <label for="formFile">sự điều chỉnh</label>
                <div class="label_wrapper">
                  <label for="formFile" class="custom-file-upload">lựa chọn
                    <input class="form-control" type="file" id="formFile" @change="fileChangehandler" style="display:none;">
                  </label>
                  <div class="label_wrapper_content">{{fileContent}}</div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6 mb-3 without_validate_wrapper">
                <!--聯絡傳真-->
                <label for="validationCustom01">liên hệ fax</label>
                <!--請輸入傳真-->
                <input
                  v-model="fax"
                  type="text"
                  class="without_validate_input"
                  id="validationCustom01"
                  placeholder="Vui lòng nhập số fax"
                  value="fax"
                />
                <!--請輸入傳真-->
                <div class="invalid-feedback">
                  Vui lòng nhập số fax
                </div>
              </div>
            </div>
            <div class="mb-3">
              <!--訊息內容-->
              <label for="validationCustom01">Nội dung tin nhắn</label>
              <!--請輸入訊息內容-->
              <textarea
                v-model="content"
                class="form-control"
                id="validationTextarea"
                placeholder="Vui lòng nhập nội dung tin nhắn"
                required
              ></textarea>
              <!--請輸入訊息內容-->
              <div class="invalid-feedback">
                Vui lòng nhập nội dung tin nhắn
              </div>
            </div>
            <div class="form-group">
              <div class="form-check">
                <input
                  v-model="check"
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="invalidCheck2"
                  required
                />
                <!--本人已閱讀並同意本公司-->
                <label class="form-check-label" for="invalidCheck2" style="color:black;">
                  Tôi đã đọc và lập kế hoạch cho công ty
                </label>
                <!--個人資料蒐集政策-->
                <a class="other__ck__text__green"
                  data-toggle="modal" 
                  data-target="#exampleModal">
                  Chính sách Thu thập Thông tin Cá nhân
                </a>
                <!--尚未同意個人資料蒐集政策-->
                <div class="invalid-feedback">
                  Chưa đồng ý với Chính sách thu thập thông tin cá nhân
                </div>
              </div>
            </div>
            <div class="modal fade" id="exampleModal"
                  tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                  <div class="modal-header">
                    <!--個人資料蒐集政策-->
                    <h5 class="modal-title" id="staticBackdropLabel">Chính sách Thu thập Thông tin Cá nhân</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                <div class="modal-body" v-html="resourceHumanResources.content">
                </div>
              </div>
              </div>
            </div>
            <!--確認送出-->
            <button class="btn btn_green btn_submit" type="submit" @click.prevent.stop="SubmitData" :disabled ="disable">
              Xác nhận để gửi
            </button>
          </form>
        </div>
      </div>
    </div>
    <div class="resource_section_four_wrapper resource__block"
    id="ResourceContactUs"
    >
      <div class="container">
        <div class="other__ck__title title__bar">
          <h2>{{resourceContactUsData.title}}</h2>
        </div>
        <div class="other__ck__textblock my-5">
          <div class="other__ck__block__left">
            <div class="other__ck__img resource__img__box">
              <div class="resource_pic_wrapper">
                <iframe :src="resourceContactUsData.googlemap" width="100%" height="350" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
              </div>
            </div>
          </div>
          <div class="other__ck__block__right">
            <div class="other__ck__title title__bar">
              <h2>{{resourceContactUsData.locationname}}</h2>
            </div>
            <div class="service__list">
              <div class="service__list__icon map__icon">
                <img src="../assets/pic/place__icon.png" alt="" />
              </div>
              <div class="service__list__content">
                <div class="service__list__content__title">
                  <p class="other__ck__text__green">
                    {{resourceContactUsData.companyname}}
                  </p>
                </div>
                <div class="service__list__content__text">
                  <p v-html="resourceContactUsData.areacontent"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="other__ck__textblock other__reverse my-5">
          <div class="other__ck__block__left">
            <div class="other__ck__title title__bar">
              <h2>{{resourceContactUsData.locationname1}}</h2>
            </div>
            <div class="service__list">
              <div class="service__list__icon map__icon">
                <img src="../assets/pic/place__icon.png" alt="" />
              </div>
              <div class="service__list__content">
                <div class="service__list__content__title">
                  <p class="other__ck__text__green">
                    {{resourceContactUsData.companyname1}}
                  </p>
                </div>
                <div class="service__list__content__text">
                  <p v-html="resourceContactUsData.areacontent1"></p>
                </div>
              </div>
            </div>
          </div>
          <div class="other__ck__block__right">
            <div class="other__ck__img resource__img__box">
              <div class="resource_pic_wrapper">
                <iframe :src="resourceContactUsData.googlemap1" width="100%" height="350" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vue-recaptcha ref="recaptcha" @verify="onVerify" @expired="onExpired" :loadRecaptchaScript="true" sitekey="6Ld_ohoeAAAAAHqE5M_OY3nX2uwAY6ki5LeYvSJv"
    size="invisible"/>
  </div>
</template>

<script>
import { apiResource } from "@/api/pages.js";
import { VueRecaptcha } from 'vue-recaptcha';
import { Toast } from "./../utils/helpers"
import formPostAPI from "./../api/formPost"
import Header from './../components/Header'
export default {
  name: "Resource",
  components: {
    Header,
    VueRecaptcha
  },
  data(){
    return{
      hash: '',
      item:{},
      resource:{},
      resourceContactUs:{},
      resourceHumanResources:{},
      resourceHumanResources1:{},
      resourceHumanResources2:{},
      resourceHumanResources3:{},
      resourceHumanResources4:{},
      resourceHumanVacancies:{},
      resourceContactUsData:{},
      name:'',
      email:'',
      phone:'',
      file:'',
      fax:'',
      content:'',
      check:false,
      token:'',
      disable: false,
      fileContent: 'Tệp PDF, kích thước giới hạn: 10MB'
    }
  },
  created(){
    this.getData()
    this.getHashValue()
  },
  mounted() {
    document.querySelector('body').scrollIntoView({behavior: "smooth"})
    setTimeout( () => {
      const target = $(`${this.hash}`).offset().top
      $(window).scrollTop(target)
    }, 100)
  },
  methods: {
    async postDataHandler () {
      const form = document.querySelector('.needs-validation')
      const content = this.content.replace(/\\r\\n|\n/g,"");
      this.disable = true
      try {
        let file = document.querySelector('input[type="file"]')
        const data_JSON = {
          name: this.name,
          email: this.email,
          phone: this.phone,
          data: this.file,
          fax: this.fax,
          content: this.content,
          token: this.token
        }
        const response = await formPostAPI.SubmitResumePost({ data_JSON })
        console.log(response)
        if(response.data.result === 'OK'){
        // if(response.data.reCAPTCHA.success){
          Toast.fire({
            icon: 'success',
            title: 'Dữ liệu đã được gửi！'
          })
          this.name = ''
          this.file = ''
          this.phone = ''
          this.email = ''
          this.fax = ''
          this.content = ''
          this.check = false
          file.value = ''
          this.fileContent = 'Tệp PDF, kích thước giới hạn: 10MB'
          form.classList.remove('was-validated')
        }
      }
      catch(e) {
        Toast.fire({
          icon: 'warning',
          title: 'Truyền dữ liệu không thành công, vui lòng đợi!'
        })
        console.log('error:',e)
      }
      this.disable = false
    },
    async getData(){
      try {
        const res = await apiResource();
        const {resource,resourceContactUs,resourceHumanResources,
        resourceHumanResources1,resourceHumanResources2,resourceHumanResources3,resourceHumanResources4,resourceHumanVacancies} = res.data;
        this.resource = resource
        this.resourceContactUs = resourceContactUs
        this.resourceHumanResources = resourceHumanResources
        this.resourceHumanResources1 = resourceHumanResources1
        this.resourceHumanResources2 = resourceHumanResources2
        this.resourceHumanResources3 = resourceHumanResources3
        this.resourceHumanResources4 = resourceHumanResources4
        this.resourceHumanVacancies = resourceHumanVacancies
        this.resourceContactUsData = JSON.parse(this.resourceContactUs.json)
      }
      catch {
        console.log('err')
      }
    },
    fileChangehandler (e) {
      let file = document.querySelector('input[type="file"]')
      if(!e.target.files[0]){
        this.fileContent = 'Tệp PDF, kích thước giới hạn: 10MB'
        return
      }
      const fileType = e.target.files[0].type.split('/')
      const type = fileType[1]
      const kbyte = Math.ceil(e.target.files[0].size / 1024) 
      if(type !== 'pdf') {
        Toast.fire({
          icon: 'warning',
          title: 'Lỗi cuốn tệp, vui lòng tải tệp PDF lên'
        })
        file.value = ''
        this.fileContent = 'Tệp PDF, kích thước giới hạn: 10MB'
        return
      }
      if(kbyte > 10240) {
        Toast.fire({
          icon: 'warning',
          title: 'Lỗi cuốn theo tệp, kích thước tệp vượt quá 10MB'
        })
        file.value = ''
        this.fileContent = 'Tệp PDF, kích thước giới hạn: 10MB'
        return
      }
      const reader = new FileReader
      reader.readAsDataURL(e.target.files[0])
      reader.onload = () => {
        this.file = reader.result
        this.fileContent = e.target.files[0].name
      }
      reader.onerror = (error) => {
        console.log('Error:', error)
      }
    },
    getHashValue(){
      if(this.$route.hash) {
        this.hash = this.$route.hash
      } else {
        this.hash = `#${this.$route.name}`
      }
    },
    async SubmitData() {
      const form = document.querySelector('.needs-validation')
      form.classList.add('was-validated')
      if(!form.checkValidity()) return
      this.$refs.recaptcha.execute();
    },
    onVerify: function (response) {
      this.token = response
      this.postDataHandler()
    },
    onExpired: function () {
      console.log('Expired')
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset() // Direct call reset method
    },
  },
};
</script>

<style lang="css">
    .modal-dialog{
      max-height: 80%;
      text-align: left;
    }
    .wrapper {
      display: flex;
      justify-content: center;
      flex-direction: column;
    }
    .other__ck__block__left{
      flex:1;
    }
    .other__ck__block__right{
      flex:1;
    }
    .form-control {
      height: 43px;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
    input[type="number"]{
        -moz-appearance: textfield;
    }
        .file-wrapper {
      display: block;
      background: #fff;
    }
    .label_wrapper{
      display: flex;
      align-items: center;
      height: 43px;
      background-color: #fff;
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
      overflow: hidden;
    }
    .custom-file-upload {
      padding: 9px;
      height: 43px;
      cursor: pointer;
      border-right: 1px solid #ccc;
      background-color: #009A44;
      color: white;
      margin-bottom: 0px !important;
    }
    .label_wrapper_content{
      padding: 0 5px;
      color: gray;
    }
    @media screen and (min-width: 768px){
      .modal-dialog {
        max-width: 70%;
        max-height: 500px;
      }
      .wrapper{
        flex-direction: row;
      }    
    }
    @media screen and (min-width: 1200px){
      .modal-dialog {
        margin-top: 20vh; 
      }  
    }
</style>